const defaultSubline = $('.hero__content--text').find('p.subline').first().clone();
const defaultContent = $('.hero__content--text').find('p:not(.subline)').first().clone();
const defaultImageUrl = $('.hero__content--img').css('background-image');

function switchHeader (event) {
    const sector = event.currentTarget.id;
    const $checkbox = $(event.currentTarget);
    const $target = $('.hero__content--text');
    let imageUrl = defaultImageUrl;
    let content = defaultContent;
    if (sector && sector !== '' && $checkbox.is(':checked')) {
        const $data = $(`.main-nav__overview[data-sectorid=${sector}]`);
        if ($data.length) {
            imageUrl = `url(${$data.children('.main-nav__overview__img').data('url')})`;
            content = $data.children('.main-nav__overview__text').find('p:not(.subline)').first().clone();
        }
    }

    $('.hero__content--img').css({ 'background-image': imageUrl });
    $target.empty().append(defaultSubline).append(content);
}

export default switchHeader;



// WEBPACK FOOTER //
// ./src/scripts/components/references/switchHeader.js